import React, { useState } from 'react';
import '../styles/PrivacyTerms.css';

const PrivacyPolicyTerms = () => {
    const [activeTab, setActiveTab] = useState('privacy');

    const currentDate = new Date().toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });

    return (
        <div className="legal-container">
            <div className="legal-header">
                <h1>Legal Information</h1>
                <p className="effective-date">Effective Date: {currentDate}</p>
            </div>

            <div className="tab-navigation">
                <button
                    className={`tab-button ${activeTab === 'privacy' ? 'active' : ''}`}
                    onClick={() => setActiveTab('privacy')}
                >
                    Privacy Policy
                </button>
                <button
                    className={`tab-button ${activeTab === 'terms' ? 'active' : ''}`}
                    onClick={() => setActiveTab('terms')}
                >
                    Terms & Conditions
                </button>
            </div>

            <div className="legal-content">
                {activeTab === 'privacy' ? (
                    <div className="privacy-policy">
                        <h2>Privacy Policy</h2>

                        <section className="policy-section">
                            <h3>1. Introduction</h3>
                            <p>Welcome to <span className="salon-name">King ang Queen</span> ("we," "our," or "us"). We are committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your personal information when you visit our website or book an appointment. By using our services, you agree to the practices described in this policy.</p>
                        </section>

                        <section className="policy-section">
                            <h3>2. Information We Collect</h3>
                            <p>We collect personal information that you voluntarily provide to us when you book a slot or express an interest in our services. The information we collect includes:</p>
                            <ul className="policy-list">
                                <li><strong>Contact Details:</strong> Name, email address, phone number, and physical address.</li>
                                <li><strong>Appointment Details:</strong> Booking preferences and service history.</li>
                                <li><strong>Payment Information:</strong> If you pay a deposit online, payment details are processed by our secure third-party payment providers. We do <strong>not</strong> store full credit card details on our servers.</li>
                                <li><strong>Technical Data:</strong> When you visit our site, we may automatically collect your IP address and browsing behavior via cookies to improve your experience.</li>
                            </ul>
                        </section>

                        <section className="policy-section">
                            <h3>3. How We Use Your Information</h3>
                            <p>We use the information we collect for the following purposes:</p>
                            <ul className="policy-list">
                                <li><strong>To Manage Appointments:</strong> To process your booking, send you confirmations, reminders, and updates regarding your appointment.</li>
                                <li><strong>To Communicate With You:</strong> To respond to your inquiries and provide customer support.</li>
                                <li><strong>For Marketing (with consent):</strong> With your permission, we may send you promotional offers, newsletters, or updates about our salon. You can opt out at any time.</li>
                                <li><strong>To Improve Our Services:</strong> To analyze how customers use our site so we can enhance your experience.</li>
                            </ul>
                        </section>

                        <section className="policy-section">
                            <h3>4. How We Share Your Information</h3>
                            <p>We do not sell, rent, or trade your personal information. We may share your data only with trusted third parties who assist us in operating our business, such as:</p>
                            <ul className="policy-list">
                                <li><strong>Scheduling Software Providers:</strong> To manage our booking system.</li>
                                <li><strong>Payment Processors:</strong> To securely handle transactions.</li>
                                <li><strong>Email/SMS Platforms:</strong> To send you appointment reminders and marketing materials (only if you have opted in).</li>
                            </ul>
                            <p>These service providers are contractually obligated to protect your data and use it only for the purposes we specify. We do not share SMS opt-in information with third parties for their own marketing purposes.</p>
                        </section>

                        <section className="policy-section">
                            <h3>5. Data Security and Retention</h3>
                            <p>We implement appropriate technical and organizational security measures to protect your personal information from unauthorized access, alteration, or destruction.</p>
                            <p>We will retain your information only for as long as necessary to fulfill the purposes outlined in this policy (e.g., to maintain your appointment history for future visits) and to comply with legal obligations (e.g., tax records).</p>
                        </section>

                        <section className="policy-section">
                            <h3>6. Your Privacy Rights</h3>
                            <p>Depending on your location, you may have the right to:</p>
                            <ul className="policy-list">
                                <li><strong>Access</strong> the personal information we hold about you.</li>
                                <li><strong>Correct</strong> inaccurate information.</li>
                                <li><strong>Delete</strong> your personal data.</li>
                                <li><strong>Withdraw Consent</strong> for marketing communications at any time.</li>
                            </ul>
                            <p>To exercise these rights, please contact us at <a href="mailto:contact@yoursalon.com">suresh94475@gmail.com</a>.</p>
                        </section>

                        <section className="policy-section">
                            <h3>7. Contact Us</h3>
                            <p>If you have questions about this Privacy Policy, please contact us:</p>
                            <ul className="contact-list">
                                <li><strong>Email:</strong> <a href="mailto:contact@yoursalon.com">suresh94475@gmail.com</a></li>
                                <li><strong>Phone:</strong> +91 88910 64655</li>
                                <li><strong>Address:</strong> SM Arcade, 2nd Floor, Near Casaba Police Station

                                    Pudussery, Palakkad, Kerala, India</li>
                            </ul>
                        </section>
                    </div>
                ) : (
                    <div className="terms-conditions">
                        <h2>Terms and Conditions</h2>

                        <section className="terms-section">
                            <h3>1. Acceptance of Terms</h3>
                            <p>By accessing or using the website of <span className="salon-name">King And Queen</span> to book appointments or purchase services, you agree to be bound by these Terms and Conditions. If you do not agree, please do not use our site or services.</p>
                        </section>

                        <section className="terms-section">
                            <h3>2. Appointments and Bookings</h3>
                            <ul className="terms-list">
                                <li><strong>Scheduling:</strong> By submitting a booking form, you request a specific time slot. We will confirm the appointment via email or text message.</li>
                                <li><strong>Accuracy:</strong> You agree to provide accurate, current, and complete information (name, email, mobile, address) during the booking process.</li>
                                <li><strong>Right to Refuse:</strong> We reserve the right to refuse service or bookings to anyone at our discretion.</li>
                            </ul>
                        </section>

                        <section className="terms-section">
                            <h3>3. Cancellations, No-Shows, and Late Arrivals</h3>
                            <ul className="terms-list">
                                <li><strong>Cancellation Policy:</strong> We require at least <span className="highlight">[Number, e.g., 24]</span> hours' notice for cancellations or rescheduling.</li>
                                <li><strong>Late Cancellations/No-Shows:</strong> Appointments cancelled with less than <span className="highlight">[Number]</span> hours' notice or missed appointments ("no-shows") may be subject to a fee of <span className="highlight">[Amount, e.g., $25]</span> or forfeiture of a deposit, if applicable.</li>
                                <li><strong>Late Arrival:</strong> If you arrive late, we may need to shorten your service to avoid delaying subsequent clients, or we may have to reschedule your appointment.</li>
                            </ul>
                        </section>

                        <section className="terms-section">
                            <h3>4. Pricing and Payments</h3>
                            <ul className="terms-list">
                                <li><strong>Prices:</strong> All prices for services are listed on our website and are subject to change without notice. We strive for accuracy but reserve the right to correct errors.</li>
                                <li><strong>Payment:</strong> Payment for services is due at the time of service unless otherwise agreed. For online deposits, payment is processed through our secure gateway.</li>
                                <li><strong>Deposits:</strong> We may require a deposit to secure a booking. Deposits are generally non-refundable for cancellations made outside of the allowed window, as they reserve your stylist's time.</li>
                            </ul>
                        </section>

                        <section className="terms-section">
                            <h3>5. Health and Safety</h3>
                            <ul className="terms-list">
                                <li><strong>Client Responsibility:</strong> You agree to inform your stylist of any relevant health conditions, allergies, or sensitivities that could affect your service or the products used (e.g., allergies to hair color, scalp conditions).</li>
                                <li><strong>Salon Environment:</strong> We strive to maintain a safe and relaxing environment. We reserve the right to refuse service to anyone exhibiting inappropriate or disruptive behavior.</li>
                            </ul>
                        </section>

                        <section className="terms-section">
                            <h3>6. Liability</h3>
                            <ul className="terms-list">
                                <li><strong>Services:</strong> We perform our services with reasonable skill and care. However, results may vary based on individual hair type, skin type, and aftercare. We are not liable for unsatisfactory results caused by a client's failure to follow aftercare instructions.</li>
                                <li><strong>Products:</strong> Our salon is not liable for allergic reactions to products used; it is the client's responsibility to disclose known allergies prior to the service.</li>
                                <li><strong>Limitation of Liability:</strong> To the maximum extent permitted by law, <span className="salon-name">King And Queen</span> shall not be liable for any indirect, incidental, or consequential damages arising from your use of our services or website.</li>
                            </ul>
                        </section>

                        <section className="terms-section">
                            <h3>7. Website Use and Intellectual Property</h3>
                            <ul className="terms-list">
                                <li><strong>Content:</strong> All text, images, logos, and designs on this website are the property of <span className="salon-name">King And Queen</span> and may not be copied or reproduced without written permission.</li>
                                <li><strong>Links:</strong> Our site may contain links to third-party websites. We are not responsible for the content or privacy practices of those sites.</li>
                            </ul>
                        </section>

                        <section className="terms-section">
                            <h3>8. Changes to Terms</h3>
                            <p>We reserve the right to update or modify these Terms at any time without prior notice. Changes will be effective immediately upon posting on the website. Your continued use of the site constitutes your acceptance of the new Terms.</p>
                        </section>

                        <section className="terms-section">
                            <h3>9. Contact Information</h3>
                            <p>For any questions regarding these Terms, please contact us at:</p>
                            <ul className="contact-list">
                                <li><strong>Email:</strong> <a href="mailto:contact@yoursalon.com">suresh94475@gmail.com</a></li>
                                <li><strong>Phone:</strong> +91 88910 64655</li>
                                <li><strong>Address:</strong> SM Arcade, 2nd Floor, Near Casaba Police Station

                                    Pudussery, Palakkad, Kerala, India</li>
                            </ul>
                        </section>
                    </div>
                )}
            </div>

            <div className="legal-footer">
                <p className="disclaimer">
                    <strong>Disclaimer:</strong> This document is for informational purposes only and does not constitute legal advice.
                    Please review with a legal professional to ensure compliance with applicable laws.
                </p>
                <p className="copyright">© {new Date().getFullYear()} King And Queen. All rights reserved.</p>
            </div>
        </div>
    );
};

export default PrivacyPolicyTerms;